// @flow

// TODO: split this to a separate package

export type Point = {x: number, y: number};

function add(a: Point, b: Point): Point {
  return {x: a.x + b.x, y: a.y + b.y};
}

function scalarMult(f: number, a: Point): Point {
  return {x: f * a.x, y: f * a.y};
}

// TODO: support for more complicated padding
export type HexGeometry = (width: number, height: number, padding: number) => {
  innerRadius: number,
  outerRadius: number,
  center: (point: Point) => Point,
  corner: (point: Point, f: number, i: number) => Point,
  hitTest: (coords: Point) => ?Point,
};

function coords(
  radius: number,
  offset: Point,
  point: Point,
): Point {
  return {
    //x: (point.x + point.y) * 3 / 2 * radius + offset.x,
    //y: (point.y - point.x) * Math.sqrt(3) / 2 * radius + offset.y,
    x: (point.x + point.y / 2) * Math.sqrt(3) * radius + offset.x,
    y: point.y * 3 / 2 * radius + offset.y,
  };
}

const a = Math.sqrt(3) / 2;
const b = 0.5;
const corners = [
  {x: -a, y: b},
  {x: -a, y: -b},
  {x: 0, y: -1},
  {x: a, y: -b},
  {x: a, y: b},
  {x: 0, y: 1},
];

function corner(
  radius: number,
  offset: Point,
  point: Point,
  f: number,
  i: number,
): Point {
  return coords(radius, add(offset, scalarMult(radius * f, corners[i])), point);
}

// TODO: render the other direction on mobile, if better fit
export default function hexGeometry(points: Array<Point>): HexGeometry {
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
	for (let point of points) {
    for (let i = 0; i < 6; i++) {
      const {x, y} = corner(1, {x: 0, y: 0}, point, 1, i);
      minX = Math.min(minX, x);
      minY = Math.min(minY, y);
      maxX = Math.max(maxX, x);
      maxY = Math.max(maxY, y);
    }
  }
  const unscaledWidth = maxX - minX;
  const unscaledHeight = maxY - minY;

  return (width: number, height: number, padding: number) => {
    const radius = Math.min((height - 2*padding) / unscaledHeight, (width - 2*padding) / unscaledWidth);
    const offset = {
      //x: ((width / unscaledWidth - radius)*unscaledWidth/2) - minX * radius,
      x: -minX * radius,
      y: ((height / unscaledHeight - radius)*unscaledHeight/2) - minY * radius,
    };
    return {
      innerRadius: Math.sqrt(3) / 2 * radius,
      outerRadius: radius,
      center(point: Point): Point {
        return coords(radius, offset, point);
      },
      corner(point: Point, f: number, i: number): Point {
        return corner(radius, offset, point, f, i);
      },
      hitTest(eventCoords: Point): ?Point {
        // TODO: maybe check the point is actually in the polygon
        let minDist = Infinity, minPoint = null;
        for (let point of points) {
          const pointCoords = coords(radius, offset, point);
          const dist = Math.sqrt((eventCoords.x - pointCoords.x)**2 + (eventCoords.y - pointCoords.y)**2);
          if (dist < radius && dist < minDist) {
            minDist = dist;
            minPoint = point;
          }
        }
        return minPoint;
      },
    };
  };
}



// WEBPACK FOOTER //
// ./src/hexGeometry.js